// The closed set of roles and tiers the permission model knows. Mirrors `Sprocket.Common.Role`
// and `Sprocket.Common.Tier` in `@platform/contracts`; `@platform/testing` pins the two together.
export const ROLES = ['PlatformAdmin', 'TenantAdmin', 'Manager', 'Agent'];
export const TIERS = ['pool', 'silo'];
export function isRoleName(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
export function isTierName(value) {
    return typeof value === 'string' && TIERS.includes(value);
}
//# sourceMappingURL=roles.js.map